import { useEffect } from "react";
import { useSocketContext } from "../context/SocketContext";

/**
 * Hook que escuta eventos do WebSocket e aciona refetch do useConversationDetails e useConversations.
 */
export const useRealtimeMessages = ({
  selectedConversationId,
  refetchConversationDetails,
  refetchConversations,
  refreshConversationMessages,
  onSocketActivity,
}) => {
  const { socket } = useSocketContext();

  useEffect(() => {
    if (!socket) return;

    const refreshForConversation = (id) => {
      if (refetchConversations) refetchConversations();

      if (parseInt(id, 10) === parseInt(selectedConversationId, 10)) {
        if (refetchConversationDetails) refetchConversationDetails();
        if (refreshConversationMessages) refreshConversationMessages(String(id));
      }
    };

    const handleMessage = (id) => {
      refreshForConversation(id);
      if (onSocketActivity) {
        onSocketActivity({ eventName: "message", conversationId: id });
      }
    };

    const handleRequest = (id) => {
      refreshForConversation(id);
      if (onSocketActivity) {
        onSocketActivity({ eventName: "request", conversationId: id });
      }
    };

    const handleReload = (id) => {
      refreshForConversation(id);
      if (onSocketActivity) {
        onSocketActivity({ eventName: "messagesReload", conversationId: id });
      }
    };

    socket.on("message", handleMessage);
    socket.on("messagesReload", handleReload);
    socket.on("request", handleRequest);

    return () => {
      socket.off("message", handleMessage);
      socket.off("messagesReload", handleReload);
      socket.off("request", handleRequest);
    };
  }, [
    socket,
    selectedConversationId,
    refetchConversationDetails,
    refetchConversations,
    refreshConversationMessages,
    onSocketActivity,
  ]);
};
